module.exports = __webpack_public_path__ + "files/75c37b8bb2f2885deb51f984a4094de5.png";